import { FC, Fragment, memo } from 'react'
import { H2 } from '@/components/atoms/typography'
import Link from '@/components/atoms/link'
import styled from 'styled-components'

type ProductDetailTitleProps = {
  name: string
  productBrand: string
  brandUrl: string
}

const ProductDetailTitle: FC<ProductDetailTitleProps> = ({
  name,
  productBrand,
  brandUrl
}) => {
  return (
    <>
      {name && (
        <RegularH2
          mb={{ desktop: 12, tablet: 12, mobile: 9 }}
          mt={9}
          data-testid="productDetailTitle"
        >
          {makeProductName(name, productBrand).map(
            ({ isBold, value }, offset) => (
              <Fragment key={offset}>
                {isBold ? (
                  <span>
                    <Link href={brandUrl}>
                      <b>{value}</b>
                    </Link>
                  </span>
                ) : (
                  replaceUnderlineForSpace(value)
                )}
              </Fragment>
            )
          )}
        </RegularH2>
      )}
    </>
  )
}

export default memo(ProductDetailTitle)

const RegularH2 = styled(H2)`
  font-weight: normal;
`

const makeProductName = (name: string, brand: string) => {
  const lowerName = name.toLowerCase()

  const brandParts = brand.split(' ')
  let matched = ''

  for (let i = brandParts.length; i > 0; i--) {
    const sub = brandParts.slice(0, i).join(' ')
    if (lowerName.includes(sub.toLowerCase())) {
      matched = sub
      break
    }
  }

  if (!matched) {
    return [{ value: name, isBold: false }]
  }

  const index = lowerName.indexOf(matched.toLowerCase())
  const before = name.slice(0, index)
  const match = name.slice(index, index + matched.length)
  const after = name.slice(index + matched.length)

  return [
    { value: before, isBold: false },
    { value: match, isBold: true },
    { value: after, isBold: false }
  ]
}

const replaceUnderlineForSpace = (value: string): string => {
  return value.replace(/_/g, ' ')
}
